import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { VowHeader } from "@/components/VowHeader";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BrandSelection = () => {
  const { roomNumber } = useParams();
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBrands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadBrands = async () => {
    try {
      const response = await axios.get(`${API}/brands`);
      const data = response.data;
      if (data.length === 1) {
        navigate(`/menu/${roomNumber}/${encodeURIComponent(data[0].name)}`, { replace: true });
        return;
      }
      setBrands(data);
    } catch (error) {
      toast.error("Failed to load brands");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-[#1c3b2e] border-t-transparent"></div>
      </div>
    );
  }

  const cardColors = ["#1c3b2e", "#8B6914", "#2D4A3E", "#6B4226"];

  return (
    <div className="min-h-screen bg-background">
      <VowHeader roomNumber={roomNumber} onBack={() => navigate("/")} />

      <div className="px-4 pt-6 pb-8 space-y-5">
        <div className="text-center mb-6">
          <h2 className="text-xl font-bold text-[#1c3b2e]">Order Fresh Meals to Your Room</h2>
          <p className="text-sm text-[#2c2c2c]/50 mt-1">Choose an outlet</p>
        </div>

        <div className="space-y-4">
          {brands.map((brand, idx) => (
            <button key={brand.name}
              onClick={() => navigate(`/menu/${roomNumber}/${encodeURIComponent(brand.name)}`)}
              className="w-full rounded-2xl overflow-hidden active:scale-[0.98] transition-transform"
              style={{ backgroundColor: cardColors[idx % cardColors.length] }}
              data-testid={`brand-${brand.name}`}>
              <div className="p-6 flex items-center gap-4">
                <div className="flex-1 text-left">
                  <h3 className="text-xl font-bold text-white leading-tight">{brand.name}</h3>
                  <p className="text-sm text-white/60 mt-1">{brand.description}</p>
                </div>
                <ChevronRight className="h-6 w-6 text-white/50 flex-shrink-0" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandSelection;
